import React, { Component } from "react";
import { Growl } from "primereact/growl";
import Spinner from "../../Common/Spinner";
import "react-datepicker/dist/react-datepicker.css";
import { InputText } from "primereact/inputtext";
import "react-inputs-validation/lib/react-inputs-validation.min.css";
import axios from "axios";
import * as appConst from "../../Common/constants";
import { AgGridReact, AgGridColumn } from "ag-grid-react";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-blue.css";

class MedicineEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mno: this.props.pData.mno,
      name: this.props.pData.name,
      qty: this.props.pData.qty,
      _id: this.props.pData._id,
      validate: false,
      hasNameError: false,
      spinnerClass: "collapse",
      dataClass: "",
      purchase: []
    };
  }

  componentDidMount() {

  }

  render() {
    return (
      <div>
        <h5 align="center"> {this.getHeading()}</h5>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>
        <div className={this.state.dataClass}>
          <div className="container-fluid">
            <div className="row p-1 border">
              <div className="col col-md-2">Medicine Name</div>
              <div className="col col-md-10">
                <InputText
                  type="text"
                  value={this.state.name}
                  onChange={e => this.setState({ name: e.target.value })}
                  style={{ width: "300px" }}
                  className="p-error"
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2">Stock</div>
              <div className="col col-md-10">
                <InputText
                  type="text"
                  keyfilter="pint"
                  value={this.state.qty}
                  onChange={e => this.setState({ qty: e.target.value })}
                  style={{ width: "300px" }}
                  className="p-error"
                />
              </div>
            </div>
            <div className="row p-1 border">
              <div className="col col-md-2"></div>
              <div className="col col-md-10">
                <button
                  onClick={this.onSaveClick}
                  className="btn btn-primary btn-md mr-2"
                >
                  Save
                </button>
                <button
                  onClick={this.onCancelClick}
                  className="btn btn-primary btn-md mr-2"
                >
                  Cancel
                </button>
              </div>
            </div>
            <Growl ref={el => (this.growl = el)} />
          </div>
        </div>
      </div>
    );
  }

  getHeading() {
    return "Edit Medicine : [" + this.state.mno + "] " + this.state.name;
  }

  onSaveClick = async e => {
    e.preventDefault();
    //this.toggleValidating(true);

    //if (!this.state.hasNameError) {

    const obj = {
      name: this.state.name,
      qty: this.state.qty

    };

    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/medicine/update/" +
        this.props.pData._id,
        obj
      )
      .then(res => {
        this.props.onClick("List", null);
      });
    // }
  };

  onCancelClick = e => {
    this.props.onClick("List", null);
  };
}

export default MedicineEdit;
